import { LoadingSpinner } from 'foundations-components/transitional/components/LoadingSpinner';
import { KEY_PREFIX } from 'marketplace-ui-common/hooks/useSearchParams';
import { useMemo } from 'react';
import { Redirect, useLocation } from 'react-router-dom';
import { ListingDetailsContainer } from '../../containers/ListingDetails';
import { Paths } from '../../constants/paths';
import { useFilterConfig } from '../../filters/hooks/useFilterConfig';
import { useParsedSearchResultsPathParams } from '../hooks/useParsedSearchResultsPathParams';
import { jsx as _jsx } from "react/jsx-runtime";
function matchSlug(slug, filter) {
  const match = filter === null || filter === void 0 ? void 0 : filter.options.find(o => o.slug === slug);
  return match ? {
    field: filter.field,
    value: match.value
  } : undefined;
}
export function SolutionsPartnersSearchResultsProxy() {
  const parsedPathParams = useParsedSearchResultsPathParams();
  const location = useLocation();
  const {
    PROFILE_CATALOG_SERVICES,
    PROFILE_INDUSTRIES,
    PROFILE_LOCATION_COUNTRY,
    loading
  } = useFilterConfig();
  const {
    params,
    isProfilePage
  } = useMemo(() => {
    if (loading) {
      return {
        params: new URLSearchParams(),
        isProfilePage: false
      };
    }
    const urlParams = new URLSearchParams(location.search);
    if (parsedPathParams.page) {
      urlParams.set(`${KEY_PREFIX}page`, parsedPathParams.page.toString());
    }

    // Each slug is matched against service (e.g. "implementation"),
    // industry (e.g. "technology"), or country (e.g. "united-states")
    // filter options. Matched slugs set the corresponding search param:
    //   /solutions/implementation → ?eco_PROFILE_CATALOG_SERVICES=IMPLEMENTATION
    //   /solutions/implementation/technology → above + &eco_PROFILE_INDUSTRIES=TECHNOLOGY
    //   /solutions/implementation/technology/united-states → all three filters
    //   /solutions/leadstreet → no match, falls back to profile page
    const slugs = [parsedPathParams.categorySlug, parsedPathParams.subcategorySlug, parsedPathParams.subcategory2Slug];
    for (const slug of slugs) {
      var _ref, _matchSlug;
      if (!slug) continue;
      const match = (_ref = (_matchSlug = matchSlug(slug, PROFILE_CATALOG_SERVICES)) !== null && _matchSlug !== void 0 ? _matchSlug : matchSlug(slug, PROFILE_INDUSTRIES)) !== null && _ref !== void 0 ? _ref : matchSlug(slug, PROFILE_LOCATION_COUNTRY);
      if (!match) {
        // Only the single-slug category route can fall back to a profile page.
        return {
          params: urlParams,
          isProfilePage: !parsedPathParams.subcategorySlug && !parsedPathParams.subcategory2Slug
        };
      }
      const key = `${KEY_PREFIX}${match.field}`;
      if (!urlParams.has(key)) {
        urlParams.set(key, match.value);
      }
    }
    return {
      params: urlParams,
      isProfilePage: false
    };
  }, [PROFILE_CATALOG_SERVICES, PROFILE_INDUSTRIES, PROFILE_LOCATION_COUNTRY, loading, location.search, parsedPathParams]);
  if (loading) {
    return /*#__PURE__*/_jsx(LoadingSpinner, {
      grow: true,
      size: "medium",
      marginBlockStart: "1600"
    });
  }
  if (isProfilePage) {
    return /*#__PURE__*/_jsx(ListingDetailsContainer, {});
  }
  const search = params.toString();
  return /*#__PURE__*/_jsx(Redirect, {
    to: {
      pathname: Paths.SEARCH_RESULTS_SOLUTIONS_PARTNERS,
      search: search ? `?${search}` : ''
    }
  });
}